// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("illustrations/sports.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-first-step_wrapper__KjIdv {
  display: grid;
  align-items: center;
  justify-content: center;
  padding: 48px;
}

.admin-first-step_team-card__9RK53 {
  background-color: var(--white-text-color);
  padding: 24px;
  border-radius: 4px;
  max-width: 611px;
}

.admin-first-step_container__kz\\+CL {
  width: 100%;
  max-width: 1080px;
}

.admin-first-step_team-card__9RK53 {
  & .admin-first-step_input__gJ3zZ {
    border: 0;
    font-size: 24px;
    font-weight: 700;
    padding-left: 0;

    &:active,
    &:focus {
      outline: none;
    }
  }
}

.admin-first-step_sport__qmDxb {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.admin-first-step_sport-list__3CTh\\+ {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.admin-first-step_illustration-container__P2vOp {
  display: grid;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 6px;
  min-height: 50px;
  padding: 32px;
}

.admin-first-step_create-team__4WJvY {
  display: flex;
  justify-content: end;
}

.admin-first-step_invitations__lFqCp {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 32px;
}

.admin-first-step_card__xSpe9 {
  border-radius: 6px;
  background-color: var(--white-text-color);
  min-width: 500px;
}

.admin-first-step_card-header__mhqlm {
  display: flex;
  flex-direction: column;
  padding: 24px;
  gap: 12px;
  border-bottom: 1px solid var(--primary-border-color);
}

.admin-first-step_card-content__tTKwH {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 24px;
}

.admin-first-step_email-input__VPrHR {
  border: none !important;
  background-color: var(--primary-background-color);
}

.admin-first-step_emails__VxlAj {
  display: grid;
  grid-template-rows: repeat(2, min-content);
  gap: 4px;
}

.admin-first-step_email-subtitle__N2u\\+s {
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 4px;
}

.admin-first-step_invitation-mails__tpmxw {
  display: grid;
  grid-template-rows: repeat(2, min-content);
  gap: 12px;
  height: 250px; /* Add fixed height - adjust this value as needed */
  overflow-y: auto;
}

.admin-first-step_invite-title__uBV2o {
  display: flex;
  gap: 8px;
  align-items: center;
}

.admin-first-step_invitation-list__sbNOt {
  display: grid;
  gap: 12px;
}

.admin-first-step_invitation-mail-card__x55a0 {
  padding: 24px;
  background-color: var(--white-text-color);
  border-radius: 4px;
  display: grid;
  grid-template-rows: repeat(5, min-content);
  gap: 12px;
}

.admin-first-step_magic-links-container__LWcfA {
  display: grid;
  grid-template-rows: repeat(2, min-content);
  gap: 24px;
  width: inherit;
}

.admin-first-step_links-header__ufRME {
  display: grid;
  grid-template-rows: repeat(2, min-content);
  gap: 12px;
}

.admin-first-step_links-container__\\+l7yU {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.admin-first-step_links-disclaimer__YW3\\+m {
  background-color: var(--light-blue-background-color);
  padding: 12px;
  border-radius: 4px;
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 12px;
  align-items: center;
}

.admin-first-step_link-card__MtOFT {
  background-color: var(--white-text-color);
  padding: 12px;
  border-radius: 4px;
  display: grid;
  grid-template-rows: repeat(2, min-content);
  gap: 12px;
  cursor: pointer;

  & p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.admin-first-step_link-card-header__OXr5z {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 12px;
  align-items: center;
}

.admin-first-step_bold__QbKLR {
  font-weight: 800;
  color: var(--start-actions-color);
}

.admin-first-step_icon__3jUvZ {
  color: var(--start-actions-color);
}

.admin-first-step_player-color__WAPoY {
  color: var(--error-text-color);
}

.admin-first-step_captain-color__IbB6r {
  color: var(--start-actions-color);
}

.admin-first-step_actions-section__8nck6 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 24px;
}

.admin-first-step_next__bVZ4B {
  display: grid;
}

.admin-first-step_next-card__hwQdn {
  width: inherit;
  display: flex;
  flex-direction: column;
  gap: 24px;
  background-color: var(--white-text-color);
  padding: 24px;
  border-radius: 4px;
}

.admin-first-step_reminder__jDPEW {
  padding: 12px;
  background-color: var(--light-green-color);
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 12px;

  & p {
    color: var(--secondary-background-color);
  }
}

@media (max-width: 1368px) {
  .admin-first-step_card__xSpe9 {
    min-width: 400px;
  }

  .admin-first-step_wrapper__KjIdv {
    padding: 24px;
  }
}

@media (max-width: 980px) {
  .admin-first-step_card__xSpe9 {
    min-width: 150px;
  }

  .admin-first-step_invitations__lFqCp {
    grid-template-columns: 1fr;
  }

  .admin-first-step_links-container__\\+l7yU {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/register/admin-first-step.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,yCAAyC;EACzC,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE;IACE,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,eAAe;;IAEf;;MAEE,aAAa;IACf;EACF;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,yDAAiD;EACjD,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,SAAS;EACT,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,aAAa,EAAE,mDAAmD;EAClE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,0CAA0C;EAC1C,SAAS;AACX;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,oDAAoD;EACpD,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,eAAe;;EAEf;IACE,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;AACF;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yCAAyC;EACzC,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;;EAET;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".wrapper {\n  display: grid;\n  align-items: center;\n  justify-content: center;\n  padding: 48px;\n}\n\n.team-card {\n  background-color: var(--white-text-color);\n  padding: 24px;\n  border-radius: 4px;\n  max-width: 611px;\n}\n\n.container {\n  width: 100%;\n  max-width: 1080px;\n}\n\n.team-card {\n  & .input {\n    border: 0;\n    font-size: 24px;\n    font-weight: 700;\n    padding-left: 0;\n\n    &:active,\n    &:focus {\n      outline: none;\n    }\n  }\n}\n\n.sport {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.sport-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.illustration-container {\n  display: grid;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  background-image: url(\"illustrations/sports.png\");\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  border-radius: 6px;\n  min-height: 50px;\n  padding: 32px;\n}\n\n.create-team {\n  display: flex;\n  justify-content: end;\n}\n\n.invitations {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 32px;\n}\n\n.card {\n  border-radius: 6px;\n  background-color: var(--white-text-color);\n  min-width: 500px;\n}\n\n.card-header {\n  display: flex;\n  flex-direction: column;\n  padding: 24px;\n  gap: 12px;\n  border-bottom: 1px solid var(--primary-border-color);\n}\n\n.card-content {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 24px;\n}\n\n.email-input {\n  border: none !important;\n  background-color: var(--primary-background-color);\n}\n\n.emails {\n  display: grid;\n  grid-template-rows: repeat(2, min-content);\n  gap: 4px;\n}\n\n.email-subtitle {\n  display: flex;\n  align-items: center;\n  justify-content: end;\n  gap: 4px;\n}\n\n.invitation-mails {\n  display: grid;\n  grid-template-rows: repeat(2, min-content);\n  gap: 12px;\n  height: 250px; /* Add fixed height - adjust this value as needed */\n  overflow-y: auto;\n}\n\n.invite-title {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.invitation-list {\n  display: grid;\n  gap: 12px;\n}\n\n.invitation-mail-card {\n  padding: 24px;\n  background-color: var(--white-text-color);\n  border-radius: 4px;\n  display: grid;\n  grid-template-rows: repeat(5, min-content);\n  gap: 12px;\n}\n\n.magic-links-container {\n  display: grid;\n  grid-template-rows: repeat(2, min-content);\n  gap: 24px;\n  width: inherit;\n}\n\n.links-header {\n  display: grid;\n  grid-template-rows: repeat(2, min-content);\n  gap: 12px;\n}\n\n.links-container {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 12px;\n}\n\n.links-disclaimer {\n  background-color: var(--light-blue-background-color);\n  padding: 12px;\n  border-radius: 4px;\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 12px;\n  align-items: center;\n}\n\n.link-card {\n  background-color: var(--white-text-color);\n  padding: 12px;\n  border-radius: 4px;\n  display: grid;\n  grid-template-rows: repeat(2, min-content);\n  gap: 12px;\n  cursor: pointer;\n\n  & p {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n\n.link-card-header {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 12px;\n  align-items: center;\n}\n\n.bold {\n  font-weight: 800;\n  color: var(--start-actions-color);\n}\n\n.icon {\n  color: var(--start-actions-color);\n}\n\n.player-color {\n  color: var(--error-text-color);\n}\n\n.captain-color {\n  color: var(--start-actions-color);\n}\n\n.actions-section {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 24px;\n}\n\n.next {\n  display: grid;\n}\n\n.next-card {\n  width: inherit;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  background-color: var(--white-text-color);\n  padding: 24px;\n  border-radius: 4px;\n}\n\n.reminder {\n  padding: 12px;\n  background-color: var(--light-green-color);\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n\n  & p {\n    color: var(--secondary-background-color);\n  }\n}\n\n@media (max-width: 1368px) {\n  .card {\n    min-width: 400px;\n  }\n\n  .wrapper {\n    padding: 24px;\n  }\n}\n\n@media (max-width: 980px) {\n  .card {\n    min-width: 150px;\n  }\n\n  .invitations {\n    grid-template-columns: 1fr;\n  }\n\n  .links-container {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `admin-first-step_wrapper__KjIdv`,
	"team-card": `admin-first-step_team-card__9RK53`,
	"container": `admin-first-step_container__kz+CL`,
	"input": `admin-first-step_input__gJ3zZ`,
	"sport": `admin-first-step_sport__qmDxb`,
	"sport-list": `admin-first-step_sport-list__3CTh+`,
	"illustration-container": `admin-first-step_illustration-container__P2vOp`,
	"create-team": `admin-first-step_create-team__4WJvY`,
	"invitations": `admin-first-step_invitations__lFqCp`,
	"card": `admin-first-step_card__xSpe9`,
	"card-header": `admin-first-step_card-header__mhqlm`,
	"card-content": `admin-first-step_card-content__tTKwH`,
	"email-input": `admin-first-step_email-input__VPrHR`,
	"emails": `admin-first-step_emails__VxlAj`,
	"email-subtitle": `admin-first-step_email-subtitle__N2u+s`,
	"invitation-mails": `admin-first-step_invitation-mails__tpmxw`,
	"invite-title": `admin-first-step_invite-title__uBV2o`,
	"invitation-list": `admin-first-step_invitation-list__sbNOt`,
	"invitation-mail-card": `admin-first-step_invitation-mail-card__x55a0`,
	"magic-links-container": `admin-first-step_magic-links-container__LWcfA`,
	"links-header": `admin-first-step_links-header__ufRME`,
	"links-container": `admin-first-step_links-container__+l7yU`,
	"links-disclaimer": `admin-first-step_links-disclaimer__YW3+m`,
	"link-card": `admin-first-step_link-card__MtOFT`,
	"link-card-header": `admin-first-step_link-card-header__OXr5z`,
	"bold": `admin-first-step_bold__QbKLR`,
	"icon": `admin-first-step_icon__3jUvZ`,
	"player-color": `admin-first-step_player-color__WAPoY`,
	"captain-color": `admin-first-step_captain-color__IbB6r`,
	"actions-section": `admin-first-step_actions-section__8nck6`,
	"next": `admin-first-step_next__bVZ4B`,
	"next-card": `admin-first-step_next-card__hwQdn`,
	"reminder": `admin-first-step_reminder__jDPEW`
};
export default ___CSS_LOADER_EXPORT___;
